import { useContext } from "react"
import { PageDataContext } from "../context/page-data-context"

export const usePageData = () => useContext(PageDataContext)

